"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.mat2MultiplyValueShader = void 0;
const gl_shader_1 = require("../gl-shader");
/**
 * @public
 * Pad float up to vec2 up with additional 1 and multiply.
 */
// language=GLSL
exports.mat2MultiplyValueShader = new gl_shader_1.GlShader(
// @formatter:off
`
#ifndef GET_MAT2_MULTIPLY_VALUE

#define GET_MAT2_MULTIPLY_VALUE 1

float mat2MultiplyValue(mat2 transform, float value)
{
    return (transform * vec2(value, 1)).x;
}

#endif
`);
//# sourceMappingURL=mat2-multiply-value-shader.js.map